// extracted by mini-css-extract-plugin
module.exports = {"rating":"_1xCO_CAQ","scoreOn":"_21T-QE7N","scoreOff":"_6byuZww9"};